import { render, staticRenderFns } from "./ThemesEditorAddBtn.vue?vue&type=template&id=284ffb0a"
import script from "./ThemesEditorAddBtn.vue?vue&type=script&setup=true&lang=js"
export * from "./ThemesEditorAddBtn.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports